import React, { useLayoutEffect, useRef } from 'react'
import { Tooltip } from '../ui/modal'
import { TIcon } from './assets/t-icon'
import { cn } from '@/lib/utils'
import { XCircleIcon } from './assets/x-circle-icon'
import { useTranslation } from 'react-i18next'

/** 口播按钮 */
export const LiveScriptButton: React.FC<{
  liveStreamScript: boolean,
  setLiveStreamScript: (liveStreamScript: boolean) => void
}> = ({
  liveStreamScript,
  setLiveStreamScript
}) => {
    const { t } = useTranslation();

    return (
      <Tooltip
        side='top'
        align='center'
        trigger={
          <div
            className="size-9 flex items-center justify-center rounded-[8px] hover:bg-[rgba(242,244,247,1)] transition-colors flex-shrink-0 cursor-pointer"
            onClick={() => setLiveStreamScript(!liveStreamScript)}
          >
            <TIcon className={cn("size-5", liveStreamScript && "text-[rgba(117,66,247,1)]")} />
          </div>
        }
        content={
          <div className='relative bg-[rgba(16,24,40,1)] px-3 py-2 rounded-[8px]'>
            <span className='text-[rgba(255,255,255,1)] text-sm font-medium'>
              {!liveStreamScript ? t('live_script.open_tooltip') : t('live_script.close_tooltip')}
            </span>
            <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-black"></div>
          </div>
        }
      />
    )
  }

/** 口播台词标签 */
export const LiveScriptLabel: React.FC<{
  liveStreamScript: boolean
  setLiveStreamScript: (value: boolean) => void
  /** 标签实际渲染宽度变化时回调（用于让外部根据多语言文案宽度自适应缩进） */
  onWidthChange?: (width: number) => void
}> = ({
  liveStreamScript,
  setLiveStreamScript,
  onWidthChange
}) => {
    const { t } = useTranslation();
    const labelRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
      const el = labelRef.current;
      if (!el || !onWidthChange) return;
      const report = () => onWidthChange(el.offsetWidth);
      report();
      if (typeof ResizeObserver === 'undefined') return;
      const ro = new ResizeObserver(report);
      ro.observe(el);
      return () => ro.disconnect();
    }, [onWidthChange, t]);

    return (
      <Tooltip
        side='top'
        align='center'
        trigger={
          <div ref={labelRef} className={cn(
            'group absolute top-0 left-0 py-0.5 px-1.5 rounded-[6px] hover:bg-[rgba(242,244,247,1)] transition-all z-10 text-sm  opacity-0 flex-shrink-0 whitespace-nowrap scale-0 bg-white select-none',
            liveStreamScript && 'opacity-100 scale-100'
          )}>
            <span className='text-sm cursor-pointer text-[rgba(117,66,247,1)]'>{t('live_script.script_label')}</span>
            <div
              className={'absolute -top-1 -right-1 opacity-0 transition-all group-hover:opacity-100'}
              onClick={() => setLiveStreamScript(false)}
            >
              <XCircleIcon className='size-[14px] hover:scale-110 transition-all active:scale-95 cursor-pointer' />
            </div>
          </div>
        }
        content={
          <div className='relative bg-[rgba(16,24,40,1)] px-3 py-2 rounded-[8px]'>
            <span className='text-[rgba(255,255,255,1)] text-sm font-medium'>
              {t('live_script.click_close_tooltip')}
            </span>
            <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-black"></div>
          </div>
        }
      />
    )
  }